













import Vue from 'vue';

export default Vue.extend({
  name: 'LandingLayout',
  data: () => ({
    logo: process.env.VUE_APP_NAVBAR_LOGO,
  }),
});
